import { APP } from '@/app.config'
import { AppIcon, Button, type IconName } from '@/components/ui'
import { useConsoleStore } from '@/store/consoleStore'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, Outlet } from 'react-router'
import './shell.css'

const NAV: { to: string; icon: IconName; labelKey: string }[] = [
  { to: '/attendance', icon: 'attendance', labelKey: 'nav.attendance' },
  { to: '/members', icon: 'members', labelKey: 'nav.members' },
  { to: '/accounts', icon: 'accounts', labelKey: 'nav.accounts' },
  { to: '/settings', icon: 'settings', labelKey: 'nav.settings' },
]

/** Refresh on return to the tab and every minute, so marks from phones show up. */
const REFRESH_MS = 60_000

export function Shell() {
  const { t } = useTranslation()
  const user = useConsoleStore((s) => s.user)
  const logout = useConsoleStore((s) => s.logout)
  const refresh = useConsoleStore((s) => s.refresh)

  useEffect(() => {
    const tick = () => {
      if (document.visibilityState === 'visible') refresh().catch(() => {})
    }
    document.addEventListener('visibilitychange', tick)
    const id = setInterval(tick, REFRESH_MS)
    return () => {
      document.removeEventListener('visibilitychange', tick)
      clearInterval(id)
    }
  }, [refresh])

  return (
    <div className="shell">
      <aside className="shell__side">
        <div className="shell__brand t-title">{APP.name}</div>
        <nav className="shell__nav" aria-label={t('navLabel')}>
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className="shell__link">
              <AppIcon name={n.icon} />
              {t(n.labelKey)}
            </NavLink>
          ))}
        </nav>
        <div className="shell__user">
          <div className="t-label">{user?.displayName}</div>
          <div className="t-body-sm shell__username">{user?.username}</div>
          <Button size="sm" icon="logout" onClick={() => void logout()}>
            {t('logout')}
          </Button>
        </div>
      </aside>
      <main className="shell__main">
        <Outlet />
      </main>
    </div>
  )
}
